module.exports = __webpack_public_path__ + "img/banner_content.8f981085.png";